module.exports = __webpack_public_path__ + "logo.png?5ccb3b05b9869bb424f2aed863a4379a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 378
// module chunks = 0